class ThemeProblemSigns extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
    this.controller = new AbortController();
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const showImmediately = () => {
      this.removeAttribute('data-animate');
      this.observer?.disconnect();
    };
    const firstLabel = this.querySelector('.feature-callouts__label');
    if (!this.hasAttribute('data-animate') || motion.matches || window.Shopify?.designMode ||
        !('IntersectionObserver' in window) || !firstLabel) {
      showImmediately();
      return;
    }
    // If CSS is unavailable or its load-failure fallback already showed the labels,
    // leave them visible instead of hiding content the shopper has already seen.
    if (getComputedStyle(firstLabel).opacity !== '0') {
      showImmediately();
      return;
    }
    this.classList.add('is-armed');
    this.observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      this.classList.add('is-revealed');
      this.observer.disconnect();
    }, { threshold: 0.15 });
    this.observer.observe(this);
    motion.addEventListener('change', showImmediately, { signal: this.controller.signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
    this.removeAttribute('data-animate');
    this.classList.remove('is-armed', 'is-revealed');
  }
}

if (!customElements.get('feature-callouts-signs')) customElements.define('feature-callouts-signs', ThemeProblemSigns);
